import React, { useState } from 'react';
import { Box, Button, Checkbox, FormControlLabel, Typography, Container } from '@mui/material';
import { Link, useNavigate } from 'react-router-dom';

const NewReservation: React.FC = () => {
  const [agreeToPolicy, setAgreeToPolicy] = useState(true);
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    if (agreeToPolicy) {
      navigate(path);
    } else {
      alert('予約を進めるには、プライバシーポリシーに同意する必要があります。');
    }
  };

  return (
    <Container maxWidth="sm" sx={{ p: { xs: 3, sm: 5 }, bgcolor: 'background.paper', border: '1px solid', borderColor: 'divider', borderRadius: "24px" }}>
      <Typography component="h1" variant="h4" sx={{ mb: 1.5 }}>医院を選ぶ</Typography>
      <Typography color="text.secondary" sx={{ mb: 4 }}>予約を希望する医院を選択してください。</Typography>
      <Box sx={{ display: 'grid', gap: 2 }}>
        <Button
          onClick={() => handleNavigation('/reservation/sekine-jibika')}
          variant="contained"
          fullWidth
          sx={{ py: 2, fontSize: '1rem' }}
        >
          せきね耳鼻咽喉科
        </Button>
        <Button
          onClick={() => handleNavigation('/reservation/wako-jibika')}
          variant="outlined"
          fullWidth
          sx={{ py: 2, fontSize: '1rem' }}
        >
          和光耳鼻咽喉科
        </Button>
        <Box mt={2}>
          <FormControlLabel
            control={
              <Checkbox
                checked={agreeToPolicy}
                onChange={(e) => setAgreeToPolicy(e.target.checked)}
                color="primary"
              />
            }
            label={
              <Typography variant="body2">
                <Link to="/privacy-policy" target="_blank" rel="noopener noreferrer">
                  プライバシーポリシー
                </Link>
                に同意して予約に進みます。
              </Typography>
            }
          />
        </Box>
      </Box>
    </Container>
  );
};

export default NewReservation;
